document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.accordion__content p').forEach(paragraph => {
    if (paragraph.innerHTML.trim() === '&nbsp;') {
      paragraph.style.display = 'none';
    }
  });



    
  
  const header = document.querySelector('header.header--transparent');
  const logo = document.querySelector('.header__logo-wrapper .image__img');
  
  function updateLogoBasedOnHeaderState() {

    // Check if the header exists and if it meets the required conditions
    if (header && 
        !header.classList.contains('is-sticky') &&
        !header.classList.contains('dropdown-active') &&
        !header.matches(':hover') &&
        !header.matches(':focus-within') &&
        !document.body.hasAttribute('mobile-menu-open') &&
        !document.body.hasAttribute('data-quick-search-open') &&
        window.pageYOffset === 0) {
      
      // If all conditions are true, use the white logo
      logo.src = "https://cdn.shopify.com/s/files/1/0719/6082/2017/files/Link_logo_white_png.png?v=1727926184";
      logo.srcset = "https://cdn.shopify.com/s/files/1/0719/6082/2017/files/Link_logo_white_png.png?v=1727926184";
    } else {
      // Otherwise, use the default black logo
      logo.src = "//da-voluce-lighting-studio.myshopify.com/cdn/shop/files/da-voluce-lighting-sutdio-logo_eb8cd4e7-9df0-4f7b-b28f-02381ab4277f.png?v=1728287174";
      logo.srcset = "//da-voluce-lighting-studio.myshopify.com/cdn/shop/files/da-voluce-lighting-sutdio-logo_eb8cd4e7-9df0-4f7b-b28f-02381ab4277f.png?v=1728287174";
    }
  }

  header.addEventListener('mouseenter', function() {
      updateLogoBasedOnHeaderState();
  });

  header.addEventListener('mouseleave', function() {
      updateLogoBasedOnHeaderState();
  });

  // Run the function when the DOM is fully loaded
  document.addEventListener('DOMContentLoaded', updateLogoBasedOnHeaderState);

  // Also run the function on page load to ensure it works after full resource loading
  window.addEventListener('load', updateLogoBasedOnHeaderState);

  // Run the function on scroll, resize, and body click events to update dynamically
  window.addEventListener('scroll', updateLogoBasedOnHeaderState);
  window.addEventListener('resize', updateLogoBasedOnHeaderState);
  // document.body.addEventListener('click', updateLogoBasedOnHeaderState);
});

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        const productItems = document.querySelectorAll('.product-item');
        if (productItems.length > 0) {
            productItems.forEach(function(product) {
                const rfqButton = product.querySelector('.omgrfq-collection-button');
                if (rfqButton && rfqButton.innerHTML.trim() !== '') {
                    const quickAddButton = product.querySelector('.product-item__quick-add');
                    if (quickAddButton) {
                        quickAddButton.style.display = 'none';
                    }
                }
            });
        }
    }, 2000);
});

document.addEventListener("DOMContentLoaded", function() {
    intervalId = setInterval(() => {
        
        function validateUsername(value, element) {
            var field = element.closest(".onst-field"),
                formFields = element.closest(".onst-register-form-fields"),
                submitButton = formFields.closest("form").querySelector(".onst-custom-form-submit"),
                passwordInput = formFields.querySelector('input[name="wcustomer[password]"]'),
                warning = field.querySelector(".onst-warning"),
                valid = 1;

            if (value !== "" && value == passwordInput.value) {
                warning.innerText = "Username cannot be the same as the password.";
                warning.classList.add("onstactive");
                valid = 0;
            }

            if (valid == 1) {
                warning.innerText = "This field is required.";
                warning.classList.remove("onstactive");
                validatePassword(passwordInput.value, passwordInput);
                submitButton.disabled = false;
            } else {
                submitButton.disabled = true;
            }
        }

        function validateConfirmPassword(value, element) {
            var field = element.closest(".onst-field"),
                formFields = element.closest(".onst-register-form-fields"),
                submitButton = formFields.closest("form").querySelector(".onst-custom-form-submit"),
                passwordInput = formFields.querySelector('input[name="wcustomer[password]"]'),
                warning = field.querySelector(".onst-warning"),
                valid = 1;

            if (value !== "" && value != passwordInput.value) {
                warning.innerText = 'The "Confirm Password" field must match the "Password" field.';
                warning.classList.add("onstactive");
                valid = 0;
            }

            if (valid == 1) {
                warning.innerText = "This field is required.";
                warning.classList.remove("onstactive");
                validatePassword(passwordInput.value, passwordInput);
                submitButton.disabled = false;
            } else {
                submitButton.disabled = true;
            }
        }

        function validatePassword(value, element) {
            var field = element.closest(".onst-field"),
                formFields = element.closest(".onst-register-form-fields"),
                submitButton = formFields.closest("form").querySelector(".onst-custom-form-submit"),
                usernameInput = formFields.querySelector('input[name="Username"]'),
                confirmPasswordInput = formFields.querySelector('input[name="Confirm Password"]'),
                warning = field.querySelector(".onst-warning"),
                valid = 1;

            if (value !== "" && !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@#$%^&+=!]{7,}$/.test(value)) {
                warning.innerText = "Password must be at least 7 characters long and contain at least one letter and one number.";
                warning.classList.add("onstactive");
                valid = 0;
            } else if (usernameInput && usernameInput.value == value && usernameInput.value !== "") {
                warning.innerText = "Password cannot be the same as the username.";
                warning.classList.add("onstactive");
                valid = 0;
            } else if (confirmPasswordInput && confirmPasswordInput.value !== value && confirmPasswordInput.value !== "") {
                warning.innerText = 'The "Password" field must match the "Confirm Password" field.';
                warning.classList.add("onstactive");
                valid = 0;
            }

            if (valid == 1) {
                warning.innerText = "This field is required.";
                warning.classList.remove("onstactive");

                var usernameWarning = usernameInput.closest(".onst-field").querySelector(".onst-warning"),
                    confirmPasswordWarning = confirmPasswordInput.closest(".onst-field").querySelector(".onst-warning");

                usernameWarning.innerText = "This field is required.";
                usernameWarning.classList.remove("onstactive");

                confirmPasswordWarning.innerText = "This field is required.";
                confirmPasswordWarning.classList.remove("onstactive");

                submitButton.disabled = false;
            } else {
                submitButton.disabled = true;
            }
        }

        let passwordInput = document.querySelector('input[name="wcustomer[password]"]'),
            usernameInput = document.querySelector('input[name="Username"]'),
            confirmPasswordInput = document.querySelector('input[name="Confirm Password"]');

        if (usernameInput) {
            usernameInput.addEventListener("keyup", (event) => validateUsername(event.target.value, event.target));
            usernameInput.addEventListener("keypress", (event) => validateUsername(event.target.value, event.target));
            usernameInput.addEventListener("change", (event) => validateUsername(event.target.value, event.target));
        }

        if (confirmPasswordInput) {
            confirmPasswordInput.addEventListener("keyup", (event) => validateConfirmPassword(event.target.value, event.target));
            confirmPasswordInput.addEventListener("keypress", (event) => validateConfirmPassword(event.target.value, event.target));
            confirmPasswordInput.addEventListener("change", (event) => validateConfirmPassword(event.target.value, event.target));
        }

        if (passwordInput) {
            passwordInput.addEventListener("keyup", (event) => validatePassword(event.target.value, event.target));
            passwordInput.addEventListener("keypress", (event) => validatePassword(event.target.value, event.target));
            passwordInput.addEventListener("change", (event) => validatePassword(event.target.value, event.target));
        }

        if (passwordInput || confirmPasswordInput || usernameInput) {
            clearInterval(intervalId);
        }
    }, 300);
});

document.addEventListener('DOMContentLoaded', function() {
    const listButton = document.querySelector('.item-layout-toggle__button[data-layout-type="list"]');
    const gridButton = document.querySelector('.item-layout-toggle__button[data-layout-type="grid"]');
    const filterbtn = document.querySelector('.filter-item[data-item-label="in stock"]');
  console.log(filterbtn);

const originalParents = new Map();

    let listView = false;

listButton.addEventListener('click', function() {
    listView = true;
    console.log('The list view button was clicked!');
    const collectionButtons = document.querySelectorAll('.omgrfq-collection-button');
    if (collectionButtons) {
        collectionButtons.forEach(button => {
            if (button.innerHTML.trim() !== '') {
                const quickAddWrappers = button.closest('.product-item__inner')?.querySelectorAll('.product-item__quick-add-wrapper');

                if (quickAddWrappers && quickAddWrappers.length > 1) {
                    const secondQuickAddWrapper = quickAddWrappers[1];

                    // Store the original parent before moving
                    const originalParent = button.parentElement;
                    originalParents.set(button, originalParent);

                    // Move the button to the second .product-item__quick-add-wrapper
                    secondQuickAddWrapper.appendChild(button);

                    const addButton = secondQuickAddWrapper.querySelector('.product-item__quick-add');
                    if (addButton) {
                        addButton.style.display = "none";
                    }
                } else {
                    console.error('Second Quick Add Wrapper not found for button:', button);
                }
            } else {
              button.remove();
            }
        });
    }
});

// Event listener for the grid view button
gridButton.addEventListener('click', function () {
    listView = false;
    console.log('The grid view button was clicked!');

    const collectionButtons = document.querySelectorAll('.omgrfq-collection-button');

    collectionButtons.forEach(button => {
        // If the button was moved before, move it back to its original parent
        const originalParent = originalParents.get(button);
        if (originalParent) {
            originalParent.appendChild(button);  // Return to the original parent
            button.style.display = 'block';  // Ensure the button is displayed
        } else {
            console.error('Original parent not found for button:', button);
        }
    });
});

// if (filterbtn) {
//   document.body.addEventListener('click', function (event) {
//     const filterbtn2 = event.target.closest('.filter-item[data-item-label="in stock"]');
//     if (filterbtn2) {
//         console.log('The filter button was clicked!');
//     }
//       if(listView){
//         console.log("List view true")
//         setTimeout(function() {
//         const collectionButtons = document.querySelectorAll('.omgrfq-collection-button');
//           if (collectionButtons) {
//             collectionButtons.forEach(button => {
//                 if (button.innerHTML.trim() !== '') {
//                     const quickAddWrappers = button.closest('.product-item__inner')?.querySelectorAll('.product-item__quick-add-wrapper');
          
//                     if (quickAddWrappers && quickAddWrappers.length > 1) {
//                         const secondQuickAddWrapper = quickAddWrappers[1];
          
//                         // Store the original parent before moving
//                         const originalParent = button.parentElement;
//                         originalParents.set(button, originalParent);
          
//                         // Move the button to the second .product-item__quick-add-wrapper
//                         secondQuickAddWrapper.appendChild(button);
          
//                         const addButton = secondQuickAddWrapper.querySelector('.product-item__quick-add');
//                         if (addButton) {
//                             addButton.style.display = "none";
//                         }
//                     } else {
//                         console.error('Second Quick Add Wrapper not found for button:', button);
//                     }
//                 } else {
//                   button.remove();
//                 }
//             });
//           }
//         }, 2500);
//       }
//   });
// } else {
//     console.error('Element with data-item-label="in stock" not found.');
// }
  
});

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const accountElement = document.querySelector('.samitaWS-account');
    const sectionElement = document.querySelector('#samita-section');
    
    if (accountElement && sectionElement) {
      sectionElement.appendChild(accountElement);
    }

    const accountDetailsHeading = document.querySelector('.samitaWS-account-details h2');
    const accountAddressHeading = document.querySelector('.samitaWS-account-address h2');
    
    if (accountDetailsHeading) {
      accountDetailsHeading.classList.add('ff-heading', 'fs-heading-3-base');
    }
    
    if (accountAddressHeading) {
      accountAddressHeading.classList.add('ff-heading', 'fs-heading-3-base');
    }

    document.querySelector('.samitaWS-account-left > .samitaWS-account-details > h2').textContent = "Other Information";

    const detailsContent = document.querySelector('.samitaWS-account-address .samitaWS-details-content');
    
    if (detailsContent) {
      if (detailsContent.textContent.trim() === '') {
        const noAddressMessage = document.createElement('p');
        noAddressMessage.textContent = 'No Address';
        
        detailsContent.appendChild(noAddressMessage);
        console.log('No Address message added to .samitaWS-details-content.');
      }
    }
    
  }, 1000);

});
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      document.querySelectorAll('.active-filters__clear').forEach(function(button) {
          button.addEventListener('click', function(event) {
              event.preventDefault();
              
              const urlParams = new URLSearchParams(window.location.search);
              const searchQuery = urlParams.get('q');
              
              if (searchQuery) {
                  window.location.href = `/search?q=${encodeURIComponent(searchQuery)}`;
              } else {
                  window.location.href = `/search`;
              }
          });
      });
    }, 2000);
});

function initCartUpdateScript() {
  function updateCartCount() {
    console.log('test');
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        var cartCount = data.item_count;
        const cartLinkCounts = document.querySelectorAll('.header__cart-link-count');
        cartLinkCounts.forEach(function(element) {
          element.textContent = cartCount;
          console.log('Success fetching cart data');
        });
      })
      .catch(error => {
        console.log('Error fetching cart data', error);
      });
  }

  const buttons = document.querySelectorAll('.samitaWS-quantity .increase, .samitaWS-quantity .decrease, .samitaWS-btn-remove, .samitaWS-clone-atc-button');
  buttons.forEach(function(button) {
    button.addEventListener('click', function() {
      updateCartCount();
    });
  });

  updateCartCount();
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    initCartUpdateScript();
  }, 3000);

  const headerCartLinks = document.querySelectorAll('.header__cart-link');
  headerCartLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      setTimeout(function() {
        initCartUpdateScript();
      }, 3000);
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.collapsible-row-list-item').forEach(item => {
    if (!item.textContent.trim()) {
      item.style.display = 'none';
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
  var container = document.querySelector('.faq-accordion');
  if (!container) return;

  // Find every H3 in the FAQ, wrap it + its next P in <details>
  Array.from(container.querySelectorAll('h3')).forEach(function(h3) {
    // Create the <details> structure
    var details = document.createElement('details');
    details.className = 'faq-item';

    var summary = document.createElement('summary');
    summary.innerHTML = h3.innerHTML;     // question text
    details.appendChild(summary);

    // Grab the next sibling if it's a P (the answer)
    var next = h3.nextElementSibling;
    if (next && next.tagName.toLowerCase() === 'p') {
      details.appendChild(next.cloneNode(true));
      next.remove();
    }

    // Replace the H3 with our new <details>
    h3.parentNode.replaceChild(details, h3);
  });
});


// Change the varuation name

document.addEventListener('DOMContentLoaded', function () {
  // Check if we're on the specific product page
  if (window.location.href.includes('4w-frosted-candle-led-globe-dimmable-e14-e27-b15-b22')) {
    // Select the label element that contains the text "Color:"
    const labelEl = document.querySelector('.product__label-wrapper label.product__label');

    if (labelEl && labelEl.textContent.includes('Color')) {
      // Replace only the "Color:" part of the text with "Bulb Type:"
      labelEl.innerHTML = labelEl.innerHTML.replace('Color:', 'Bulb Type:');
    }
  }
});
